import { ActionTypes } from "@/App/constants/actionTypes";
import { TransmissionTypes } from "@/types";
import { NavigateFunction } from "react-router";

type UploadManualClaimBatchAction = {
  type: typeof ActionTypes.UPLOAD_BATCH_TRANSMISSION_MANUAL_CLAIM_BATCH;
  payload: TransmissionTypes.ManualClaimBatchUploadFile;
  formName: string;
  navigate: NavigateFunction;
};

export const uploadManualClaimBatch = (data: TransmissionTypes.ManualClaimBatchUploadFile, formName: string, navigate: NavigateFunction): UploadManualClaimBatchAction => {
  return {
    type: ActionTypes.UPLOAD_BATCH_TRANSMISSION_MANUAL_CLAIM_BATCH,
    payload: data,
    formName,
    navigate,
  };
};

export type ManualClaimBatchActions = UploadManualClaimBatchAction;
